import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CompareSocial } from "@/components/CompareSocial";

export const RelocAppPost = ({ g }) => {
  const [post, setPost] = useState(null);
  const load = useCallback(() => api.get(`/relocation/guides/${g.id}/app/instagram`).then((r) => setPost(r.data?.id ? r.data : null)).catch(() => {}), [g.id]);
  useEffect(() => { load(); }, [load]);
  if (!g.files?.toolkit) return null;
  return (
    <div data-testid="reloc-app-post">
      <p className="eyebrow mb-3">Free app preview · Instagram</p>
      <CompareSocial c={g} base={`/relocation/guides/${g.id}/app`} post={post} reload={load} zipName={`${g.destination}-app-preview-instagram.zip`}
        blurb="A 4-slide carousel showing the Mobile Relocation App on a phone: chapter 1 with its illustration and a “Read chapter 1 free” headline, the contents with locked chapters, bookmarks, notes and reading progress, and a closing call to action, plus a ready caption and hashtags." />
    </div>
  );
};
